"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Kinnser = void 0;
const helper_1 = require("../../helper");
const EmrConstants_1 = require("../../EmrConstants");
class Kinnser {
    constructor() {
        this.isEditPatientUI = false;
    }
    /**********************************************************************************************************************
     *                     START : KINNSER Software Parser
     * ********************************************************************************************************************/
    /**
     * @function kinnserSoftwareParser
     * @param pastedData
     * @summary Kinnser Software Parser @pastedData string break by session to session
     * @returns {callback}
     */
    parse(pastedData, event, callbackEmit) {
        var _a, _b, _c;
        console.log("Calling parser : kinnser");
        try {
            let sendCallBackData = {};
            if (pastedData.indexOf("Location where home health services were provided:") != -1) {
                this.isEditPatientUI = true;
                sendCallBackData =
                    this.kinnserSoftwereParserFromEditSession(pastedData);
            }
            else {
                this.isEditPatientUI = false;
                //**Session 1 Patient name*/
                const sessionFirst = pastedData.substr(0, pastedData.indexOf("Patient Information"));
                //**Session 2 Patient Information*/
                const sessionSecond = (0, helper_1.substrInBetween)(pastedData, "Patient Information", "Insurance");
                const patientInfo = this.gettingPatientDetails(sessionFirst, sessionSecond);
                //**Session 3 Insurance*/
                const sessionThird = (0, helper_1.substrInBetween)(pastedData, "Insurance", "Allergies");
                const insurance = this.getInsurance(sessionThird);
                //**Session 6 Emergency Contact*/
                const sessionSix = (0, helper_1.substrInBetween)(pastedData, "Emergency Contact:", "Primary Physician:");
                //**Session 7 Primary Physician*/
                const sessionSeven = (0, helper_1.substrInBetween)(pastedData, "Primary Physician:", "Pharmacy:");
                //**Session 8 Pharmacy*/
                const sessionEight = (0, helper_1.substrInBetween)(pastedData, "Pharmacy:", "Comments");
                const physicianInfo = this.getPrimaryPhysician(sessionSix, sessionSeven, sessionEight);
                //**Session 9 Comments*/
                const comment = this.getComment(pastedData);
                // In Kinnser's patient-details header the MRN is the parenthetical at
                // the end of the name line (e.g. "Doe, John R (494)"), just above the
                // "WellSky ID" line — isolate that line so phone-number parens elsewhere
                // don't match.
                const mrnNameLine = (_a = sessionFirst
                    .substr(0, sessionFirst.indexOf("WellSky ID"))
                    .trim()
                    .split("\n")
                    .filter(Boolean)
                    .pop()) !== null && _a !== void 0 ? _a : "";
                const mrn = (_c = (_b = mrnNameLine.match(/\(([^)]+)\)\s*$/)) === null || _b === void 0 ? void 0 : _b[1]) === null || _c === void 0 ? void 0 : _c.trim();
                sendCallBackData = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, patientInfo), insurance), physicianInfo), comment), (mrn && { mrn }));
            }
            //@callback
            callbackEmit({ parseData: sendCallBackData });
        }
        catch (error) {
            //For Error logs
            callbackEmit({
                parseData: {},
                isDataParsed: 0,
                errorMessage: error ? error === null || error === void 0 ? void 0 : error.message : error,
                errorStack: error.stack,
            });
        }
    }
    kinnserSoftwereParserFromEditSession(pastedData) {
        //**Session 1 Patient Information*/
        const sessionFirst = (0, helper_1.substrInBetween)(pastedData, "First Name:", "Primary Language:");
        const sessionSecond = (0, helper_1.substrInBetween)(pastedData, "Residence Name:", "Not Applicable");
        const patientInfo = this.gettingPatientDetails(sessionFirst, sessionSecond);
        //**Session 3 Insurance*/
        const sessionThird = (0, helper_1.substrInBetween)(pastedData, "Insurance", "Medicaid Number:");
        const insurance = this.getInsurance(sessionThird);
        //**Session 6 Emergency Contact*/
        const sessionSix = (0, helper_1.substrInBetween)(pastedData, "Emergency Contact", "Insurance");
        //**Session 7 Primary Physician*/
        const sessionSeven = (0, helper_1.substrInBetween)(pastedData, "Associated Physicians", "Guarantor");
        //**Session 8 Pharmacy*/
        const sessionEight = (0, helper_1.substrInBetween)(pastedData, "Pharmacy", "Associated Physicians");
        const physicianInfo = this.getPrimaryPhysician(sessionSix, sessionSeven, sessionEight);
        //**Session 9 Comments*/
        const comment = this.getComment(pastedData);
        return Object.assign(Object.assign(Object.assign(Object.assign({}, patientInfo), insurance), physicianInfo), comment);
    }
    /**
     * @function gettingPatientDetails
     * @param sessionFirst {String}
     * @param sessionSecond {String}
     * @summary Getting Patient name, number, email, dob, address from kinnser
     */
    gettingPatientDetails(sessionFirst, sessionSecond) {
        if (!sessionSecond) {
            return {};
        }
        let convertToArray = sessionFirst;
        if (!this.isEditPatientUI) {
            convertToArray = sessionSecond.replace(/\n/g, "$hg").split("$hg")[1];
        }
        return {
            patientInfo: Object.assign(Object.assign(Object.assign({}, this.patientName(sessionFirst)), this.patientPhoneNumberWithAddress(sessionSecond)), { dob: (0, helper_1.getDOB)(convertToArray) }),
        };
    }
    /**
     * @function getInsurance
     * @param sessionThird
     * @summary Getting Insurance from kinnser
     */
    getInsurance(sessionThird) {
        if (!sessionThird) {
            return {};
        }
        //Copy From Edit session
        if (this.isEditPatientUI) {
            const insuranceValue = sessionThird.substring(sessionThird.indexOf("MBI") + 3);
            if (insuranceValue) {
                //Primary Insurance and Secondary Insurance
                return { insurance: (0, helper_1.trim)(insuranceValue) };
            }
        }
        else {
            const convertToArray = sessionThird.replace(/\n/g, "$hg").split("$hg");
            //Primary Insurance and Secondary Insurance
            return {
                insurance: convertToArray[0] ? convertToArray[0] : convertToArray[1],
            };
        }
    }
    /**
     * @function getPrimaryPhysician
     * @param data
     * @param sessionEight
     * @summary Getting Physician and Pharmacy from kinnser
     */
    getPrimaryPhysician(sessionSix, sessionSeven, sessionEight) {
        const primaryPhy = {
            info: {
                physician: [
                    {
                        name: "",
                        phoneNo: "",
                        countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                        sortOrder: 1,
                    },
                ],
                pharmacy: [...this.getPharmacy(sessionEight)],
                careGiver: [this.getCaregiver(sessionSix)],
            },
        };
        //Blank data Return
        if (!sessionSeven) {
            return primaryPhy;
        }
        /*********************************************************************
         * USER COPY PASTE FROM EDIT PATIENT SCREEN
         *******************************************************************/
        if (this.isEditPatientUI) {
            const phyName = (0, helper_1.substrInBetween)(sessionSeven, "Referring/Primary Physician:", "CJR");
            if (phyName) {
                primaryPhy.info.physician[0].name = (0, helper_1.trim)(phyName);
            }
        }
        else {
            /*********************************************************************
             * USER COPY PASTE FROM PATIENT DETAILS SCREEN
             *******************************************************************/
            sessionSeven = sessionSeven.trim();
            //Find name
            const nameInString = sessionSeven.substr(0, sessionSeven.indexOf("Address"));
            //Primary Physician name
            if (nameInString) {
                primaryPhy.info.physician[0].name = nameInString.trim();
            }
            //**Update String for Number of Address*/
            sessionSeven = (0, helper_1.substrInBetween)(sessionSeven, "State ID", "NPI");
            const numbers = (0, helper_1.phoneNumbers)(sessionSeven);
            if (numbers && numbers.length) {
                const number = numbers[0] ? numbers[0].replace(/[\s-()]/g, "") : "";
                primaryPhy.info.physician[0].phoneNo = (0, helper_1.changeNumberUSFormat)(number);
            }
        }
        //@Return
        return primaryPhy;
    }
    /**
     * @function getPharmacy
     * @param data
     */
    getPharmacy(data) {
        const pharmacyData = {
            name: "",
            phoneNo: "",
            countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
            sortOrder: 1,
        };
        /*********************************************************************
         * USER COPY PASTE FROM EDIT PATIENT SCREEN
         *******************************************************************/
        if (this.isEditPatientUI) {
            const caverGiverData = data.split("\n");
            //Caregiver Name
            if (caverGiverData[0].indexOf("Name:") !== -1 &&
                caverGiverData[1].indexOf("Address One:") == -1) {
                pharmacyData.name = caverGiverData[1];
            }
            //Get PhoneNumber
            if (pharmacyData.name) {
                const getNumberFromString = data.replace(/\s+/g, "");
                const numbers = (0, helper_1.phoneNumbers)(getNumberFromString);
                if (numbers && (0, helper_1.arrayLength)(numbers)) {
                    const number = numbers[0].replace(/[\s-()]/g, "");
                    pharmacyData.phoneNo = (0, helper_1.changeNumberUSFormat)(number);
                }
            }
        }
        else {
            /*********************************************************************
             * USER COPY PASTE FROM PATIENT DETAILS SCREEN
             *******************************************************************/
            //Blank data Return
            if (!data) {
                return [pharmacyData];
            }
            data = data.trim();
            //**Find name: Before Phone:*/
            const nameInString = data.substr(0, data.indexOf("Phone:"));
            //Primary Physician name
            if (nameInString) {
                pharmacyData.name = nameInString.trim();
            }
            //**Update String for Number*/
            const numbers = (0, helper_1.phoneNumbers)(data);
            if (numbers && numbers.length) {
                const number = numbers[0].replace(/[\s-()]/g, "");
                pharmacyData.phoneNo = (0, helper_1.changeNumberUSFormat)(number);
            }
        }
        //@Return
        return pharmacyData.phoneNo ? [pharmacyData] : [];
    }
    getCaregiver(data) {
        var _a, _b, _c, _d, _e;
        const caregiverData = {
            name: "",
            phoneNo: "",
            countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
            sortOrder: 1,
        };
        //Blank data Return
        if (!data) {
            return caregiverData;
        }
        /*********************************************************************
         * USER COPY PASTE FROM EDIT PATIENT SCREEN
         *******************************************************************/
        if (this.isEditPatientUI) {
            const caverGiverData = data
                .substr(0, data.indexOf("Contact Address:"))
                .split("\n");
            //Loop
            for (let fIndex = 0; fIndex < caverGiverData.length; fIndex++) {
                const text = caverGiverData[fIndex];
                const nextText = caverGiverData[fIndex + 1];
                //Caregiver Name
                if (text.indexOf("Name:") !== -1 &&
                    nextText.indexOf("Relationship:") == -1) {
                    caregiverData.name = nextText;
                }
                //Add Relationship
                if (caregiverData.name &&
                    text.indexOf("Relationship:") !== -1 &&
                    nextText.indexOf("Contact Phone:") == -1) {
                    if (nextText) {
                        caregiverData.name += ` (${nextText})`;
                    }
                }
            }
            //Get PhoneNumber
            if (caregiverData.name) {
                const getNumberFromString = data.replace(/\s+/g, "");
                const numbers = (0, helper_1.phoneNumbers)(getNumberFromString);
                if (numbers && numbers.length) {
                    const number = numbers[0].replace(/[\s-()]/g, "");
                    caregiverData.phoneNo = (0, helper_1.changeNumberUSFormat)(number);
                }
            }
        }
        else {
            /*********************************************************************
             * USER COPY PASTE FROM PATIENT DETAILS SCREEN
             *******************************************************************/
            data = data.trim();
            //Find name
            let nameInString = data.substr(0, data.indexOf("Address"));
            //caregiver name
            if (nameInString) {
                nameInString = nameInString.trim();
                const nameConvertToArray = nameInString.split(",");
                const careName = `${nameConvertToArray[1] ? nameConvertToArray[1] : ""} ${nameConvertToArray[0]}`;
                //**Return caregiver data*/
                if (!careName) {
                    return caregiverData;
                }
                caregiverData.name = careName;
                caregiverData.name = caregiverData.name.trim();
            }
            ////Update String for Number
            data = (_b = (_a = data === null || data === void 0 ? void 0 : data.split("Address")) === null || _a === void 0 ? void 0 : _a.pop()) === null || _b === void 0 ? void 0 : _b.trim();
            /**Getting Number */
            const numbers = data && (0, helper_1.phoneNumbers)(data);
            if (numbers && numbers.length) {
                const number = numbers[0] ? numbers[0].replace(/[\s-()]/g, "") : "";
                caregiverData.phoneNo = (0, helper_1.changeNumberUSFormat)(number);
            }
            if (caregiverData.name) {
                ////Update String for Number
                data = (_d = (_c = data === null || data === void 0 ? void 0 : data.split("Relationship")) === null || _c === void 0 ? void 0 : _c.pop()) === null || _d === void 0 ? void 0 : _d.trim();
                const findRelationship = data === null || data === void 0 ? void 0 : data.split(`\t`);
                //**relationship not mention*/
                if (findRelationship && findRelationship.length > 1) {
                    const isNumber = +((_e = findRelationship[findRelationship.length - 1]) === null || _e === void 0 ? void 0 : _e.slice(-2));
                    //find relationship
                    const relationship = findRelationship[findRelationship.length - 1];
                    if (isNaN(isNumber)) {
                        //Bind name with Relationship
                        caregiverData.name += ` - ${relationship}`;
                    }
                }
            }
        }
        //@Return
        return caregiverData;
    }
    /**
     * @function patientPhoneNumberWithAddress
     * @param pastedData
     * @summary Patient number or Address both are same session
     */
    patientPhoneNumberWithAddress(pastedData) {
        const info = {
            phoneNo: "",
            address: {
                placeName: "",
            },
        };
        /*********************************************************************
         * USER COPY PASTE FROM EDIT PATIENT SCREEN
         *******************************************************************/
        if (this.isEditPatientUI) {
            const dataToArray = pastedData.split("\n");
            //Set Address
            for (let fIndex = 0; fIndex < dataToArray.length; fIndex++) {
                const text = dataToArray[fIndex];
                const nextText = dataToArray[fIndex + 1];
                if (text.indexOf("Address:") != -1 &&
                    nextText.indexOf("ZIP Code:") == -1) {
                    info.address.placeName = (0, helper_1.trim)(nextText);
                }
                if (text.indexOf("City:") != -1 && nextText.indexOf("State:") == -1) {
                    info.address.placeName += `,${(0, helper_1.trim)(nextText)}`;
                }
                if (text.indexOf("State:") != -1) {
                    if (nextText.indexOf("Phone One:") == -1) {
                        info.address.placeName += `,${(0, helper_1.trim)(nextText)}`;
                    }
                    break; //Loop Break
                }
            }
            //Add Number
            let dataToReplaceString = pastedData.replace(/\n/g, "");
            dataToReplaceString = (0, helper_1.substrInBetween)(dataToReplaceString, "Phone One:", "Email:").replace(/\s+/g, "");
            const numbers = (0, helper_1.phoneNumbers)(dataToReplaceString);
            if (numbers && (0, helper_1.arrayLength)(numbers)) {
                const number = numbers[0] ? numbers[0].replace(/[\s-()]/g, "") : "";
                info.phoneNo = (0, helper_1.changeNumberUSFormat)(number);
            }
        }
        else {
            /*********************************************************************
             * USER COPY PASTE FROM PATIENT DETAILS SCREEN
             *******************************************************************/
            let findNumberOrAddress = pastedData;
            //**Update string : Getting data from between Referral Date and Email Address */
            const numberAddressInArray = (0, helper_1.substrInBetween)(findNumberOrAddress, "Referral Date", "Email Address")
                .replace(/\n/g, "$hg")
                .split("$hg");
            if (!numberAddressInArray) {
                return info;
            }
            findNumberOrAddress = numberAddressInArray.join("\t");
            //Break numbers
            const numbers = (0, helper_1.phoneNumbers)(findNumberOrAddress);
            //find number
            if (numbers && numbers.length) {
                const number = numbers[0] ? numbers[0].replace(/[\s-()]/g, "") : "";
                info.phoneNo = (0, helper_1.changeNumberUSFormat)(number);
                //Update string
                findNumberOrAddress = findNumberOrAddress.substr(0, findNumberOrAddress.indexOf(numbers[0]));
                //**Remove All extra Space from address */
                info.address.placeName = findNumberOrAddress
                    ? findNumberOrAddress.replace(/\s+/g, " ")
                    : "";
            }
            else {
                //Get first index
                info.address.placeName = findNumberOrAddress.split("\t")[0];
            }
        }
        //@Return address or phoneNo
        return info;
    }
    /**
     * @function patientName
     * @param sessionFirst {String}
     * @summary Getting Patient First name, Last name from string
     * @returns {name} FullName
     */
    patientName(sessionFirst) {
        const name = {
            firstName: "",
            lastName: "",
        };
        /*********************************************************************
         * USER COPY PASTE FROM EDIT PATIENT SCREEN
         *******************************************************************/
        if (this.isEditPatientUI) {
            sessionFirst = sessionFirst.substr(0, sessionFirst.indexOf("Suffix:"));
            //Convert to Array
            const sessionFirstToArray = sessionFirst.split("\n");
            //Loop
            for (let fIndex = 0; fIndex < sessionFirstToArray.length; fIndex++) {
                const text = sessionFirstToArray[fIndex];
                const nextText = sessionFirstToArray[fIndex + 1];
                //FirstName
                if (text.indexOf("Middle Name:") == -1 && fIndex == 0) {
                    name.firstName = (0, helper_1.trim)(text);
                }
                //Middle Name
                if (text.indexOf("Middle Name:") != -1 &&
                    nextText.indexOf("Last Name:") == -1) {
                    name.lastName = `${(0, helper_1.trim)(nextText)} `;
                }
                //Last Name
                if (text.indexOf("Last Name:") != -1 && nextText) {
                    name.lastName += `${(0, helper_1.trim)(nextText)}`;
                }
            }
        }
        else {
            /*********************************************************************
             * USER COPY PASTE FROM PATIENT DETAILS SCREEN
             *******************************************************************/
            //**Break string Before WellSky Id.*/
            let nameSession = sessionFirst.substr(0, sessionFirst.indexOf("WellSky ID"));
            if (!nameSession) {
                return name;
            }
            nameSession = nameSession.trim();
            const convertToArray = nameSession
                .replace(/\n/g, "$hg")
                .split("$hg");
            //Verify name Array
            if (!convertToArray && !(convertToArray === null || convertToArray === void 0 ? void 0 : convertToArray.length)) {
                return name;
            }
            if (convertToArray[convertToArray.length - 1].match(/[,)]/g)) {
                let fullName = convertToArray[convertToArray.length - 1].replace(/,./g, " ");
                fullName = fullName.replace(/\s+/g, " ");
                const fullNameToArray = fullName.split(" ");
                //Patient Name
                name.firstName = fullNameToArray[1]; //FirstName
                name.lastName = fullNameToArray[0]; //LastName
            }
        }
        //@Return name
        return name;
    }
    /**
     * @function getComment
     * @param comment
     * @summary Getting Comment filed from kinnser
     */
    getComment(comment) {
        if (this.isEditPatientUI) {
            const commentSession = (0, helper_1.substrInBetween)(comment, "Comments:", "Attachments");
            if (commentSession) {
                return { about: commentSession };
            }
        }
        else {
            const commentInArray = comment.split("Comments");
            let commentText = "Comments: " + commentInArray[1].trim();
            const patientInfo = (0, helper_1.substrInBetween)(comment, "Patient Information", "Insurance");
            const phoneNumbersFromPatientInfo = (0, helper_1.phoneNumbers)(patientInfo);
            const additionalComments = phoneNumbersFromPatientInfo
                .slice(1)
                .map((x) => "Alternate number: " + x);
            return { about: [...additionalComments, commentText].join("\n") };
        }
    }
}
exports.Kinnser = Kinnser;
